import { useTheme } from '@mui/material';

export default function TestAudioIcon() {
  const theme = useTheme();
  return (
    <svg width='60' height='60' viewBox='0 0 60 60' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M0 30C0 13.4315 13.4315 0 30 0C46.5685 0 60 13.4315 60 30C60 46.5685 46.5685 60 30 60C13.4315 60 0 46.5685 0 30Z'
        fill={theme.palette.primary.light}
      />
      <g clip-path='url(#clip0_43468_127186)'>
        <path
          d='M34.2645 32.0315C34.3943 31.9452 34.5436 31.8925 34.6989 31.8784C34.8542 31.8643 35.0106 31.8891 35.1539 31.9507L40.6805 34.4269C40.8667 34.5065 41.0222 34.6442 41.1236 34.8196C41.225 34.9949 41.2669 35.1984 41.243 35.3995C41.0609 36.7601 40.3909 38.0083 39.3575 38.9119C38.3241 39.8155 36.9977 40.3131 35.625 40.312C31.3981 40.312 27.3443 38.6329 24.3555 35.644C21.3666 32.6552 19.6875 28.6014 19.6875 24.3745C19.6865 23.0018 20.184 21.6754 21.0876 20.642C21.9912 19.6086 23.2394 18.9386 24.6 18.7565C24.8011 18.7327 25.0046 18.7745 25.1799 18.8759C25.3553 18.9773 25.4931 19.1328 25.5727 19.319L28.0488 24.8503C28.1097 24.9924 28.1344 25.1473 28.1209 25.3012C28.1075 25.4552 28.0561 25.6034 27.9715 25.7327L25.4672 28.7105C25.3784 28.8445 25.3258 28.9993 25.3147 29.1597C25.3036 29.3201 25.3344 29.4807 25.4039 29.6257C26.373 31.6097 28.4238 33.6358 30.4137 34.5956C30.5594 34.6648 30.7207 34.6949 30.8816 34.6828C31.0425 34.6706 31.1975 34.6168 31.3313 34.5265L34.2645 32.0315Z'
          stroke={theme.palette.primary.main}
          stroke-width='1.875'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_43468_127186'>
          <rect width='30' height='30' fill='white' transform='translate(15 15)' />
        </clipPath>
      </defs>
    </svg>
  );
}
